@if (product(); as product) {
  @if (product.url) {
    <mat-card class="col productCard product" (click)="onProductClick(product)">
      <mat-card-content class="justify-content-center">
        <div class="d-flex">
          @if (product.icon === 'nifi') {
            <mat-icon svgIcon="nifi"></mat-icon>
          } @else {
            <mat-icon>{{ product.icon }}</mat-icon>
          }
          <span class="px-2">{{ product.title }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  }
}
